// The roster page: the lineup slider, one tab per roster, the middle player's age and HLTV rating (bottom left) and
// links (bottom right). Ported from the approved concept (concept/src/09-pages.js and 07-slider.js).
import { $, $$, place, setText, decode, onPageIn } from 'fx';
import { createSlider, renderLinks, srList } from 'slider';

const view = $('[data-roster]');
if (view) init(view);

function init(view) {
  const D = JSON.parse($('#roster-data', view).textContent);
  const T = D.strings;
  // A roster without players: five "To be announced" places, each with the placeholder photo.
  const placeholders = () => [1, 2, 3, 4, 5]
    .map((n) => ({ name: T.player.replace('[n]', n), meta: T.tba, img: D.placeholder, links: [], placeholder: true }));
  const rosters = (D.rosters.length ? D.rosters : [{ id: 'main', label: '', players: [] }])
    .map((r) => ({ ...r, players: r.players.length ? r.players : placeholders() }));
  const byId = (id) => rosters.find((r) => r.id === id) || rosters[0];
  const asked = new URLSearchParams(location.search).get('roster');
  let current = byId(asked).id;

  const tabs = $$('[data-roster-tab]', view);
  const caret = $('#roster-caret', view);
  const heading = $('#roster-h', view);
  const stats = $('#player-stats', view);
  const socials = $('#player-socials', view);
  const slideData = (r) => r.players.map((p) => ({ img: p.img, name: p.name, meta: p.meta, person: true }));

  const roster = createSlider({
    el: $('#roster-slider', view),
    strip: $('#roster-strip', view),
    live: $('#roster-live', view),
    scope: view,
    layout: 'lineup',
    keys: true,
    labels: { swipe: T.swipe, next: T.next, previous: T.previous, position: T.position },
    data: slideData(byId(current)),
    onFocus: (i) => showPlayer(i),
    onEnterKey: () => { const a = $('#psocial-list a', view); if (a) a.focus(); }
  });

  // Age and HLTV rating bottom left, links bottom right, for the player in the middle.
  function showPlayer(i) {
    const p = byId(current).players[i];
    if (!p) return;
    const age = p.age != null && p.age !== '' ? String(p.age) : '';
    const n = Number(p.rating);
    const rating = p.rating == null || p.rating === '' ? '' : Number.isFinite(n) ? n.toFixed(2) : String(p.rating);
    $('#stat-age-box', view).hidden = !age;
    $('#stat-rating-box', view).hidden = !rating;
    stats.hidden = !age && !rating;
    [['#stat-age', age], ['#stat-rating', rating]].forEach(([id, v]) => {
      if (!v) return;
      const el = $(id, view);
      setText(el, v);
      decode(el, { step: 70, hold: 220 });
    });
    const links = p.links || [];
    socials.hidden = !links.length;
    if (!links.length) return;
    socials.setAttribute('aria-label', T.socials.replace('[name]', p.name));
    const label = $('#psocials-label', view);
    setText(label, T.follow.replace('[name]', p.name));
    decode(label, { step: 22, hold: 140 });
    renderLinks($('#psocial-list', view), links);
  }

  function mark() {
    tabs.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.rosterTab === current)));
    const r = byId(current);
    if (r.label) heading.textContent = T.heading.replace('[name]', r.label);
    srList($('#sr-roster', view), r.players.map((p) => `${p.name}, ${p.meta}`), (i) => roster.goTo(i));
  }
  const placeCaret = (instant) => place(caret, tabs.find((b) => b.dataset.rosterTab === current), instant, true);

  // Another roster: the lineup pixelates out and the new one loads in; the address follows (?roster=academy).
  function setRoster(id) {
    if (id === current || !rosters.some((r) => r.id === id)) return;
    current = id;
    mark();
    placeCaret(false);
    roster.setData(slideData(byId(id)));
    const url = new URL(location.href);
    if (id === rosters[0].id) url.searchParams.delete('roster'); else url.searchParams.set('roster', id);
    try { history.replaceState(history.state, '', url); } catch (e) { /* history unavailable */ }
  }
  tabs.forEach((b) => b.addEventListener('click', () => setRoster(b.dataset.rosterTab)));

  mark();
  placeCaret(true);
  window.addEventListener('resize', () => placeCaret(true));
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => placeCaret(true));

  onPageIn(() => {
    $$('.view-top .crumb, .tabs button', view).forEach((c, k) => decode(c, { delay: 200 + k * 90, step: 18 }));
    roster.enter();
  });
}
